import PATH from 'crono-fe-common/constants/path';

export const LIST_DETAIL_PATH = `${PATH.LISTS}/:listId`;
